"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuperLegacyBaseDriver = void 0;
var __1 = require("../..");
var test_utils_1 = require("react-dom/test-utils");
var SuperLegacyBaseDriver = /** @class */ (function () {
    function SuperLegacyBaseDriver(elem) {
        this.elem = elem;
    }
    SuperLegacyBaseDriver.prototype.find = function (selector) {
        return this.elem.querySelector(selector);
    };
    SuperLegacyBaseDriver.prototype.findAll = function (selector) {
        var elems = this.elem.querySelectorAll(selector);
        return Array.prototype.slice.call(elems);
    };
    SuperLegacyBaseDriver.prototype.getAllTextBySelector = function (selector) {
        return this.findAll(selector).map(function (e) { return e.textContent || ''; });
    };
    SuperLegacyBaseDriver.prototype.getText = function (selector) {
        return this.find(selector).textContent || '';
    };
    SuperLegacyBaseDriver.prototype.isChecked = function (selector) {
        var elem = this.elem.querySelector(selector + ':checked');
        return elem ? true : false;
    };
    SuperLegacyBaseDriver.prototype.clickOn = function (selector) {
        var event = document.createEvent('HTMLEvents');
        event.initEvent('click', true, false);
        this.find(selector).dispatchEvent(event);
    };
    SuperLegacyBaseDriver.prototype.clickOnElement = function (elem) {
        if (!elem) {
            throw new Error('Element does not exist. Unable to click on it');
        }
        var event = document.createEvent('HTMLEvents');
        event.initEvent('click', true, false);
        elem.dispatchEvent(event);
        // Simulate.click(elem);
    };
    SuperLegacyBaseDriver.prototype.mouseDownOnElement = function (elem) {
        if (!elem) {
            throw new Error('Element does not exist. Unable to click on it');
        }
        var event = document.createEvent('HTMLEvents');
        event.initEvent('mousedown', true, false);
        test_utils_1.Simulate.mouseDown(elem);
    };
    SuperLegacyBaseDriver.prototype.test = function () {
        var event = document.createEvent('HTMLEvents');
        event.initEvent('mousedown', true, false);
        test_utils_1.Simulate.mouseDown(document.body);
    };
    SuperLegacyBaseDriver.prototype.getInputValue = function (selector) {
        var elem = this.find(selector);
        return elem.value;
    };
    SuperLegacyBaseDriver.prototype.getInputValueByElement = function (elem) {
        if (!elem) {
            throw new Error('Element does not exist. Unable to click on it');
        }
        else {
            var input = elem;
            return input.value;
        }
    };
    SuperLegacyBaseDriver.prototype.enterValue = function (selector, newValue) {
        var elem = this.find(selector);
        elem.value = newValue;
        test_utils_1.Simulate.change(elem);
    };
    SuperLegacyBaseDriver.prototype.enterValueByElem = function (elem, newValue) {
        if (!elem) {
            throw new Error('Element does not exist. Unable to click on it');
        }
        else {
            var input = elem;
            input.value = newValue;
            test_utils_1.Simulate.change(elem);
        }
    };
    SuperLegacyBaseDriver.prototype.simulateKeyPress = function (selector, keyCode) {
        var elem = this.find(selector);
        var keysMap = __1.keyCodes;
        var keyName = Object.keys(__1.keyCodes).reduce(function (prev, curr) { return prev || (keysMap[curr] === keyCode ? curr : null); }, null) || 'n/a';
        test_utils_1.Simulate.keyDown(elem, { key: keyName, keyCode: keyCode, which: keyCode });
    };
    SuperLegacyBaseDriver.prototype.simulateEnterPressOn = function (selector) {
        return this.simulateKeyPress(selector, __1.keyCodes.enter);
    };
    SuperLegacyBaseDriver.prototype.simulateMouseEnter = function (selector) {
        var elem = this.find(selector);
        test_utils_1.Simulate.mouseOver(elem);
    };
    SuperLegacyBaseDriver.prototype.isChildVisible = function (selector) {
        return !!this.find(selector);
    };
    SuperLegacyBaseDriver.prototype.isVisible = function () {
        return this.elem ? true : false;
    };
    SuperLegacyBaseDriver.prototype.hasClass = function (selector, className) {
        return this.find(selector).classList.contains(className);
    };
    SuperLegacyBaseDriver.prototype.numericalValueOf = function (selector) {
        return parseInt(this.find(selector).textContent || '', 10);
    };
    SuperLegacyBaseDriver.prototype.attributeOf = function (selector, attr) {
        return this.find(selector).getAttribute(attr) || '';
    };
    SuperLegacyBaseDriver.prototype.numericalAttributeOf = function (selector, attr) {
        return parseInt(this.find(selector).getAttribute(attr) || '', 10);
    };
    SuperLegacyBaseDriver.prototype.numericalAttributeListOf = function (selector, attr) {
        return this.findAll(selector)
            .map(function (e) { return parseInt(e.getAttribute(attr) || '', 10); });
    };
    SuperLegacyBaseDriver.prototype.findByText = function (selector, text) {
        return this.findAll(selector)
            .filter(function (e) { return e.textContent === text; })[0];
    };
    SuperLegacyBaseDriver.prototype.findInPopover = function (selector) {
        return document.body.querySelector('.Popover ' + selector);
    };
    SuperLegacyBaseDriver.prototype.findAllInPopover = function (selector) {
        return Array.prototype.slice.call(document.body.querySelectorAll('.Popover ' + selector));
    };
    SuperLegacyBaseDriver.prototype.clickOnNthChild = function (selector, idx) {
        var elem = this.find("".concat(selector, ":nth-child(").concat(idx + 1, ")"));
        this.clickOnElement(elem);
    };
    SuperLegacyBaseDriver.prototype.changeCheckboxValue = function (selector, value) {
        this.find(selector).checked = value;
        this.enterValue(selector, value.toString());
    };
    SuperLegacyBaseDriver.prototype.simulateMouseLeave = function (selector) {
        var elem = this.find(selector);
        test_utils_1.Simulate.mouseOut(elem);
    };
    return SuperLegacyBaseDriver;
}());
exports.SuperLegacyBaseDriver = SuperLegacyBaseDriver;
// export class BaseFactory {
// 	static create<T>()
// }
//# sourceMappingURL=legacy-base-driver.js.map